import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { __ } from 'react-i18n';

interface Props {
  onStock: number | string;
  unit?: string;
  productInfo?: boolean;
}

function StockInfo({ onStock, unit, productInfo = false }: Props) {
  const isAvailable = onStock > 0;
  const productTabText = onStock > 0 ? `${__('Skladom')}` : __('Vypredané');
  const productInfoText = onStock > 0 ? `${onStock} ${unit}` : __('Vypredané');
  const availabilityText = productInfo ? productInfoText : productTabText;

  return (
    <StockCount available={isAvailable} productInfo={productInfo}>
      <SvgIcon
        width={isAvailable ? 16 : 24}
        height={isAvailable ? 16 : 24}
        viewBox={isAvailable ? '0 0 16 16' : '0 0 24 24'}
        marginRight={8}
        icon={isAvailable ? IconType.check : IconType.x}
        fill={isAvailable ? '#A5BBA2' : '#EB676C'}
        alt={isAvailable ? __('Skladom') : __('Vypredané')}
        title={isAvailable ? __('Skladom') : __('Vypredané')}
      />
      {availabilityText}{' '}
    </StockCount>
  );
}

const StockCount = styled.span<{
  available: boolean;
  productInfo: boolean;
}>`
  font-family: ${({ theme }) => theme.font.primary};
  display: inline-block;
  white-space: nowrap;
  font-size: ${rem(14)};
  line-height: ${rem(17)};
  color: ${({ available }) => (available ? '#A5BBA2' : '#EB676C')};
  margin: ${({ productInfo }) => (productInfo ? '0 auto' : '0')};

  // svg {
  //   width: ${rem(12)};
  //   height: ${rem(12)};
  // }
`;

export { StockInfo };
